<svelte:options accessors />

<script context="module" lang="ts">
	export type States = 'nuetral' | 'valid' | 'invalid' | 'active';
</script>

<script lang="ts">
	export let DBCol = '';
	export let Title: null | string = 'OneTwoThree';
	export let InsideTitle: null | string = Title;
	export let ShowCount = true;
	export let Value = '';
	export let MaxLength = 100;
	export let Required = true;
	let ErrorMsg = 'ErrorMsg';
	let outlineEl;
	let ErrorEl;
	let inputEl: HTMLInputElement;
	let lblColors = { nuetral: 'black', active: '#3b71ca', valid: 'green', invalid: 'red' };
	let borderColors = { nuetral: 'black', active: '#3b71ca', valid: 'green', invalid: 'red' };
	let state: States = 'nuetral';
	let inputFocused = false;
	function onFocus() {
		inputFocused = true;
		state = 'nuetral';
	}
	function onBlur() {
		inputFocused = false;
		state = 'invalid';
	}
	function onInput() {
		state = 'active';
	}
	function focus() {
		inputEl.focus();
	}
</script>

<div id="TextInput_{DBCol}_form-outline" class="form-outline" bind:this={outlineEl}>
	<input
		type="text"
		id="TextInput_{DBCol}"
		class="form-control"
		maxlength={MaxLength}
		name={InsideTitle ? InsideTitle : ''}
		on:input={onInput}
		on:blur={onBlur}
		on:focus={onFocus}
		bind:this={inputEl}
		bind:value={Value}
		required={Required}
	/>
	{#if InsideTitle}
		<label class="form-label" for="TextInput_{DBCol}" color={lblColors[state]}>{InsideTitle}</label>
	{/if}
	<div class="invalid-tooltip" id="TextInput_{DBCol}Error" bind:this={ErrorEl}>{ErrorMsg}</div>

	{#if ShowCount && inputFocused}
		<div class="form-helper">
			<div class="form-counter">{Value.length} / 100</div>
		</div>
	{/if}
	<div class="form-notch">
		<div class="form-notch-leading" style="width: 9px;" />
		<div class="form-notch-middle" style="width: 0px;" />
		<div class="form-notch-trailing" />
	</div>
	<div class="msg-spacer" />
</div>
